import React from "react";
import ToolsOverview from "../../../components/dashboard/tools/ToolsOverview";
import DashboardHeader from "../../../components/dashboard/dashboardHeader";

const ToolsOverviewPage = () => {
  return <ToolsOverview />;
};

export { ToolsOverviewPage as ToolsOverview };
